<template>
  <div class="app">
    <!-- 头部导航 -->
    <header class="header">
      <div class="container">
        <h1 class="title">株洲市芦淞区中医骨伤专科医院</h1>
        <p class="subtitle">主要领导团队介绍</p>
      </div>
    </header>

    <!-- 主体内容 -->
    <main class="main container">
      <!-- 领导团队介绍 -->
      <section class="section team">
        <h2 class="section-title">主要领导团队</h2>
        <p class="team-intro">株洲市芦淞区中医骨伤专科医院拥有一支经验丰富、技术精湛的领导团队，他们传承百年正骨技艺，结合现代医学技术，为患者提供优质的骨伤诊疗服务。</p>
        
        <div class="team-grid">
          <!-- 张进 -->
          <div class="team-card" v-for="member in leadershipTeam" :key="member.name">
            <div class="member-image">
              <img :src="member.image" alt="领导照片" class="rounded-circle">
            </div>
            <div class="member-info">
              <h3 class="member-name">{{ member.name }}</h3>
              <p class="member-title">{{ member.title }}</p>
              <div class="member-bio">
                <p>{{ member.bio }}</p>
                <p v-if="member.specialty"><strong>专业擅长：</strong>{{ member.specialty }}</p>
                <p v-if="member.achievements"><strong>成就荣誉：</strong>{{ member.achievements }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>株洲市芦淞区中医骨伤专科医院 &copy; {{ currentYear }} 版权所有</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "LeadershipIntroduction",
  data() {
    return {
      leadershipTeam: [
        {
          name: "张进",
          title: "院长/北张正骨第七代核心传承人",
          image: require('@/assets/yyimages/张进.jpg'),
          bio: "北张正骨创始人张光靖的第七代嫡系子孙，毕业于南华大学医学院临床专业。1996年大学毕业后跟随北张正骨第六代核心传承人伯父张健民、姑妈张正平学习家传正骨，并师从北张正骨第六代传人“全国十大骨伤名老中医”、“全国名老中医”孙达武教授学习北张正骨一年。参加工作后，又分别在株洲市中医伤科医院、医科大学附属第一医院进修学习，之后一直扎根姚家坝卫生院中医骨伤科临床工作。",
          specialty: "精研北张正骨技法，娴熟运用“北张正骨”手法及自制的外敷、内服药治疗各类骨折，对各种创伤骨折、陈旧性骨折骨不连、退行性老年骨质疏松、退行性骨病等均有独特疗效。其治愈率高、康复快、费用低廉、接近零创伤的治疗方法，避免了手术和二次手术的痛苦。",
        },
        {
          name: "龙航宇",
          title: "麻醉医师",
          image: require('@/assets/yyimages/龙航宇.jpg'),
          bio: "毕业于南华大学临床专业，芦淞区白关镇姚家坝卫生院担任麻醉医师，师从北张正骨第七代核心传承人张进学习正骨技法。2012年在331医院进修内儿科，2018年在株洲市中医骨伤科医院麻醉科进修。",
          specialty: "擅长骨伤、骨病患者的各种急、慢性疼痛的管理治疗和内科常见病多发病的诊治，能熟练运用鸡尾酒疗法治疗各类急慢性疼痛和术后镇痛。",
        },
        {
          name: "钟继华",
          title: "骨伤科主任/全科医师",
          image: require('@/assets/yyimages/钟继华.jpg'),
          bio: "毕业于湖南中医药大学，本科，全科医师，现任白关镇姚家坝卫生院骨伤科主任，师从北张正骨第七代核心传承人张进，系统学习北张正骨技法，并深得北张正骨的精髓。2012年在湖南省直中医院疼痛科进修学习一年，2015年在株洲市伤科医院进修膝关节科，同年跟随贺新宁主任学习脊柱外科。",
          specialty: "擅长于各类骨折、关节脱位的闭合复位、开放复位及对创伤外科、内科等常见病、多发病的治疗。",
          achievements: "2018年获评株洲市首届“中国医师节”优秀基层医师、芦淞区“十佳医师”荣誉称号。"
        },
        // {
        //   name: "张旭",
        //   title: "骨科医师",
        //   image: require('@/assets/yyimages/张旭.jpg'),
        //   bio: "毕业于南华大学临床专业，师从北张正骨第七代核心传承人张进学习正骨技法十余年。2016年跟随上海石氏伤科黄声教授学习膝关节保守治疗新疗法，2019年跟随亚洲整脊泰斗谢庆良教授学习AHT整脊技术。",
        //   specialty: "擅长四肢骨折、关节脱位的手法复位、小夹板固定，熟练运用中医药及手法对颈腰膝急、慢性疼痛的治疗、各类退行性疾病等常见病、多发病的治疗。",
        // },
        {
          name: "李红",
          title: "骨科医师",
          image: require('@/assets/yyimages/李红.jpg'),
          bio: "毕业于南华大学临床专业，2012年8月至今在芦淞区白关镇姚家坝卫生院工作，师从北张正骨第七代核心传承人张进，并在株洲市三三一医院骨科（十区)进修。2016年当选芦淞区第五届区人大代表，2017年当选芦淞区第五届工会代表，2019年在株洲市中心医院进行全科医生培训。",
          specialty: "擅长各种骨折、关节脱位的手法复位、小夹板固定，以及内科的多发病、常见病的诊治。",
        },
                {
          name: "龙志鹏",
          title: "骨科医师",
          image: require('@/assets/yyimages/龙志鹏.jpg'),
          bio: "毕业于湖南中医药大学中医骨伤专业，从事骨伤科医师工作14年，现任株洲市芦淞区中医骨伤专科医院正骨科主治医师。曾先后在浏阳市骨伤科医院、浏阳市三口骨伤科医院学习工作。",
          specialty: "擅长四肢各类骨折的手术治疗，及各类骨折脱位的手法整复夹板外固定，能熟练运用中西医结合方法治疗各种骨折创伤的治疗，加快病情康复，缩短患者治疗时间。",
        },
                        {
          name: "张飞",
          title: "内科医师",
          image: require('@/assets/yyimages/张飞.jpg'),
          bio: "内科主治医师、骨干全科医师、株洲市315卫生人才、株洲地区国家临床新药特药临床试验报名专家、湖南省医师协会会员、国家二级健康管理师、株洲市中医药和中西医结合学会络病专业委员会委员。1995年，发表论文辩证治疗骨质增生，获得全国乡村优秀论文三等奖；1993年，四川南部县痔瘘专科医院学习；1995年，在长沙政治军官进修学院医院学习颈动脉加压治疗脑中风瘫痪；2019年，中南大学附属湘雅二医院高级皮肤病培训班学习；2016年，在株洲州市331医院学习；2024年在中南大学湘雅附属医院株洲市中心医院学习；2025年获得中国中医药研究促进会中医人才技能培训证书；2025年5月，获得全国乡村医师能力提升工程(株洲）培训班优秀学员荣誉证书",
          specialty: "长期扎根基层，工龄34年，成功治疗罕见病吞咽神经瘫痪，擅长治疗心脑血管疾病，对疑难杂症，运用中医药物治疗，具有较为独特疗效。",
        }
      ]
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

body {
  background-color: #f9f9f9;
  color: #333;
  line-height: 1.6;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 头部样式 */
.header {
  background: linear-gradient(135deg, #4CAF50, #388E3C);
  color: white;
  padding: 80px 0 60px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.header::after {
  content: "";
  position: absolute;
  bottom: -50px;
  left: 0;
  width: 100%;
  height: 100px;
  background: white;
  border-radius: 50% 50% 0 0;
}

.title {
  font-size: 2.8rem;
  margin-bottom: 15px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 800px;
  margin: 0 auto;
}

/* 主体内容样式 */
.main {
  padding: 60px 0;
}

.section {
  margin-bottom: 80px;
  position: relative;
}

.section-title {
  font-size: 2rem;
  text-align: center;
  margin-bottom: 30px;
  color: #333;
  position: relative;
}

.section-title::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #4CAF50;
  border-radius: 3px;
}

.team-intro {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 50px;
  color: #555;
  font-size: 1.1rem;
}

/* 团队网格样式 */
.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 30px;
}

.team-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.team-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.1);
}

.member-image {
  width: 100%;
  height: 460px;
  overflow: hidden;
}

.member-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.team-card:hover .member-image img {
  transform: scale(1.05);
}

.member-info {
  padding: 25px;
}

.member-name {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 8px;
}

.member-title {
  font-size: 1rem;
  color: #4CAF50;
  margin-bottom: 15px;
  font-weight: normal;
}

.member-bio p {
  margin-bottom: 12px;
  color: #666;
  font-size: 0.95rem;
  line-height: 1.7;
}

.member-bio strong {
  color: #4CAF50;
  font-weight: 600;
}

/* 页脚样式 */
.footer {
  background-color: #333;
  color: white;
  padding: 40px 0;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .title {
    font-size: 2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .section-title {
    font-size: 1.6rem;
  }
  
  .team-grid {
    grid-template-columns: 1fr;
  }
  
  .member-image {
    height: 250px;
  }
}
</style>